import React, { useContext, useEffect, Fragment } from "react";
import { useParams } from "react-router-dom";
import { SeguradoraContext } from "../SeguradoraContext";
import Formulario from "../../../../../Components/Cadastro/Formulario/Formulario";

const FormularioSeguradora = () => {
  const { values, setValues, getDetailHandler } = useContext(SeguradoraContext);
  let { id } = useParams();

  useEffect(() => {
    getDetailHandler(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      data: {
        ...values.data,
        [name]: value,
      },
    });
  }

  return (
    <Fragment>
      <Formulario context={SeguradoraContext}>
        <div className="col-12 col-md-8 form-group">
          <label>Nome da Seguradora</label>
          <input
            disabled={values.formDisabled}
            className="form-control uppercase"
            type="text"
            maxLength="100"
            name="seguradoraDescricao"
            value={values.data.seguradoraDescricao}
            onChange={onChangeInput}
          />
        </div>
        <div className="col-12 col-md-2 form-group">
          <label>Status</label>
          <select
            disabled={values.formDisabled}
            className="form-control"
            name="seguradoraStatus"
            value={values.data.seguradoraStatus}
            onChange={onChangeInput}
          >
            <option className="disabled"></option>
            <option value="A"> Ativo </option>
            <option value="I"> Inátivo </option>
          </select>
        </div>
      </Formulario>
    </Fragment>
  );
};

export default FormularioSeguradora;
